import { render, staticRenderFns } from "./CircleSelectObjectDrawer.vue?vue&type=template&id=2b59bb44&scoped=true&"
import script from "./CircleSelectObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./CircleSelectObjectDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./CircleSelectObjectDrawer.vue?vue&type=style&index=0&id=2b59bb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b59bb44",
  null
  
)

export default component.exports